import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Container from '@mui/material/Container';
import StaticLoader from '../../components/mui/MuiLoader/StaticLoader/StaticLoader';

const Logout = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('meta.title')}</title>
      </Helmet>
      <Container maxWidth="xs">
        <StaticLoader />
      </Container>
    </>
  );
};

export default Logout;
